define('dcf-figcaption-toggle',["exports", "./dcf-utility", "./dcf-button-toggle"], function (_exports, _dcfUtility, _dcfButtonToggle) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.DCFFigcaptionToggleTheme = _exports.DCFFigcaptionToggle = void 0;
  function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
  function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
  function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
  function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
  function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
  function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
  function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
  function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
  function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
  var DCFFigcaptionToggleTheme = /*#__PURE__*/function () {
    // Sets up the theme
    function DCFFigcaptionToggleTheme() {
      _classCallCheck(this, DCFFigcaptionToggleTheme);
      this.toggleButtonInnerHTML = "<svg class=\"dcf-h-4 dcf-w-4 dcf-fill-current\"\n        width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" aria-hidden=\"true\">\n      <path class=\"dcf-btn-toggle-figcaption-icon-open\"\n        d=\"M1,3h19c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1H1C0.4,1,0,1.4,0,2C0,2.6,0.4,3,1,3z\"/>\n        '<path class=\"dcf-btn-toggle-figcaption-icon-open\"\n        d=\"M1,8h15c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1H1C0.4,6,0,6.4,0,7C0,7.6,0.4,8,1,8z\"/>\n      <path class=\"dcf-btn-toggle-figcaption-icon-close-1\"\n        d=\"M1,13h22c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1H1c-0.6,0-1,0.4-1,1C0,12.6,0.4,13,1,13z\"/>\n      <path class=\"dcf-btn-toggle-figcaption-icon-close-2\"\n        d=\"M1,13h22c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1H1c-0.6,0-1,0.4-1,1C0,12.6,0.4,13,1,13z\"/>\n      <path class=\"dcf-btn-toggle-figcaption-icon-open\"\n        d=\"M1,18h18c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1H1c-0.6,0-1,0.4-1,1C0,17.6,0.4,18,1,18z\"/>\n      <path class=\"dcf-btn-toggle-figcaption-icon-open\"\n        d=\"M1,23h15c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1H1c-0.6,0-1,0.4-1,1C0,22.6,0.4,23,1,23z\"/>\n    </svg>";
      this.toggleButtonClassList = ['dcf-btn', 'dcf-btn-inverse-tertiary', 'dcf-absolute', 'dcf-z-1', 'dcf-d-flex', 'dcf-ai-center', 'dcf-pt-4', 'dcf-pb-4', 'dcf-white', 'dcf-btn-toggle-figcaption'];
      this.figcaptionClassList = ['dcf-absolute', 'dcf-left-0', 'dcf-top-0', 'dcf-h-100%', 'dcf-w-100%', 'dcf-z-1', 'dcf-figcaption-toggle'];
    }

    // Allows us to set the theme variables if they are defined and we match the types
    _createClass(DCFFigcaptionToggleTheme, [{
      key: "setThemeVariable",
      value: function setThemeVariable(themeVariableName, value) {
        if (themeVariableName in this && _typeof(value) == _typeof(this[themeVariableName])) {
          this[themeVariableName] = value;
        }
      }
    }]);
    return DCFFigcaptionToggleTheme;
  }();
  _exports.DCFFigcaptionToggleTheme = DCFFigcaptionToggleTheme;
  var DCFFigcaptionToggle = /*#__PURE__*/function () {
    // Set up the button
    function DCFFigcaptionToggle(figcaptions, theme) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      _classCallCheck(this, DCFFigcaptionToggle);
      if (theme instanceof DCFFigcaptionToggleTheme) {
        this.theme = theme;
      } else {
        this.theme = new DCFFigcaptionToggleTheme();
      }

      // Copy the Keys without copying the references
      // Objects plus their properties and arrays are pass by reference
      this.toggleKeys = [];
      if (Array.isArray(options.toggleKeys)) {
        this.toggleKeys = _toConsumableArray(options.toggleKeys);
      } else if (options.toggleKeys !== null && options.toggleKeys !== undefined && options.toggleKeys !== '') {
        this.toggleKeys.push(options.toggleKeys);
      }
      this.onKeys = [];
      if (Array.isArray(options.onKeys)) {
        this.onKeys = _toConsumableArray(options.onKeys);
      } else if (options.onKeys !== null && options.onKeys !== undefined && options.onKeys !== '') {
        this.onKeys.push(options.onKeys);
      }
      this.offKeys = [];
      if (Array.isArray(options.offKeys)) {
        this.offKeys = _toConsumableArray(options.offKeys);
      } else if (options.offKeys !== null && options.offKeys !== undefined && options.offKeys !== '') {
        this.offKeys.push(options.offKeys);
      }

      // Create a random ID for the button
      this.uuid = _dcfUtility.DCFUtility.uuidv4();

      // Store the button inputted (always will be an array )
      this.figcaptions = figcaptions;
      if (NodeList.prototype.isPrototypeOf(this.figcaptions)) {
        this.figcaptions = Array.from(this.figcaptions);
      } else if (!Array.isArray(this.figcaptions)) {
        this.figcaptions = [this.figcaptions];
      }
    }

    // The names of the events to be used easily
    _createClass(DCFFigcaptionToggle, [{
      key: "initialize",
      value:
      // Initialize the buttons that were inputted in the constructor
      function initialize() {
        var _this = this;
        // Loops through each one
        this.figcaptions.forEach(function (figcaption, index) {
          // Get figure and validate it
          var figure = figcaption.parentElement;
          if (figure !== null && figure.tagName !== 'FIGURE') {
            throw new Error('Figcaption-Toggle Missing Figure Tag Parent');
          }

          // Set figure classes/styles
          figure.classList.add('dcf-relative');
          if (figcaption.id === '') {
            figcaption.id = _this.uuid.concat('-figcaption-toggle-', index);
          }
          if (_this.theme.figcaptionClassList) {
            _this.theme.figcaptionClassList.forEach(function (cssClass) {
              figcaption.classList.add(cssClass);
            });
          }

          // Set up the caption button
          var toggleButton = document.createElement('button');
          toggleButton.dataset.controls = figcaption.id;
          toggleButton.dataset.labelOn = 'Show caption';
          toggleButton.dataset.labelOff = 'Hide caption';
          toggleButton.dataset.postfix = index;
          toggleButton.dataset.startExpanded = 'false';
          toggleButton.innerHTML = _this.theme.toggleButtonInnerHTML;

          // Sets the toggleButton classes
          if (_this.theme.toggleButtonClassList) {
            _this.theme.toggleButtonClassList.forEach(function (cssClass) {
              toggleButton.classList.add(cssClass);
            });
          }

          // Append the button and initialize it
          figure.appendChild(toggleButton);
          var toggleButtonObj = new _dcfButtonToggle.DCFToggleButton(toggleButton, {
            toggleKeys: _this.toggleKeys,
            onKeys: _this.onKeys,
            offKeys: _this.offKeys
          });
          toggleButtonObj.initialize();
        });
      }
    }], [{
      key: "events",
      value: function events(name) {
        // Define any new events
        var events = {};
        Object.freeze(events);

        // Forward the events from the DCFToggleButton
        if (_dcfButtonToggle.DCFToggleButton.events(name) !== undefined) {
          return _dcfButtonToggle.DCFToggleButton.events(name);
        }

        // Return the name of the event if it exists if not it will return undefined
        return name in events ? events[name] : undefined;
      }
    }]);
    return DCFFigcaptionToggle;
  }();
  _exports.DCFFigcaptionToggle = DCFFigcaptionToggle;
});

